export default {
  methods: {
    hiddenDropdown(e) {
      const dropdowns = document.querySelectorAll('.dropdown');
      dropdowns.forEach(dropdown => {
        if (dropdown.contains(e.target)) {
          return;
        }
        dropdown.classList.remove('open');
      });
    },
    hiddenAllDropdown() {
      const dropdowns = document.querySelectorAll('.dropdown');
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    }
  }
}
